/**
 * Feature configuration — edge branch (all available features enabled).
 */
export const features = {
  // Sprint 1-3
  passwordIndicator: true,
  reorderPhotos: true,
  previewDraft: true,
  averageReviews: true,
  addOns: true,
  favourites: true,
  attachFiles: true,
  cart: true,
  vatValidation: true,
  socialShare: true,
  profilePhotoCrop: true,
  videoPlayer: true,
  smtp: true,
  captchaRecaptcha: false,
  captchaTurnstile: true,
  cookieConsent: true,
  cronJobs: true,
  profileAddresses: true,
  shippingDelivery: true,
  listingsApi: true,
  mailchimp: true,
  twilioSms: true,
  pdfInvoice: true,
  voucherCodes: true,
  listingFiles: true,
  // Sprint 4
  contactForm: true,
  sendgrid: true,
  vacationMode: true,
  agoraVideo: true,
  // Sprint 5
  transactionMetadata: true,
  intercom: true,
  notificationPreferences: true,
  stripeSubscriptions: true,
  // Sprint 6
  paypal: true,
  adminApi: true,
  // Sprint 7
  slackNotifications: true,
  gdprDeleteAccount: true,
  // Sprint 8
  webhookReceiver: true,
  // Sprint 9
  gtm: true,
  listingBadges: true,
  whatsapp: true,
  emailTemplates: true,
  announcementBanner: true,
  listingStats: true,
  waitlist: true,
  userTiers: true,
  downloadableContent: true,
  userBlocking: true,
  savedSearches: true,
  sitemapXml: true,
  priceRules: true,
  ipGeoDetect: true,
  autoTranslation: true,
  customWebhooks: true,
  rateLimiting: true,
  referralTracking: true,
  exportData: true,
  contentReports: true,
  multiCurrency: true,
  featuredListings: true,
  userInvites: true,
  reviewResponse: true,
  qrCode: true,
  bookingReminder: true,
  imageCompression: true,
  socialProof: true,
  scheduledPublish: true,
  loginAttempts: true,
  listingDuplicator: true,
  userMilestones: true,
  twoFactorAuth: true,
  flashSales: true,
  abandonedCart: true,
  affiliateLinks: true,
  inAppNotifications: true,
  liveSearch: true,
  darkMode: true,
  listingComparisons: true,
  multiLanguage: true,
  onboardingChecklist: true,
  maintenanceMode: true,
  bookingNotes: true,
  activityLog: true,
  ageVerification: true,
  listingEndDate: true,
  helpCenter: true,
  customPages: true,
  listingAlerts: true,
  bulkUpload: true,
  sellerDashboard: true,
  listingApproval: true,
  commissionOverride: true,
  guestInquiry: true,
  tipping: true,
  bookingReminders: true,
  reviewRequest: true,
  googleCalendar: true,
  userVerification: true,
  pushNotifications: true,
  priceNegotiation: true,
  dynamicPricing: true,
  depositPayment: true,
  inventoryAlert: true,
  loyaltyPoints: true,
  earlyBirdDiscount: true,
  recurringBooking: true,
  passwordlessLogin: true,
  listingTemplate: true,
  searchSuggestions: true,
  userGrouping: true,
  bookingExtension: true,
  abandonedSignup: true,
  lastMinuteDeals: true,
  bundleDiscount: true,
  eventBooking: true,
  taxCalculator: true,
  membershipGating: true,
  geoRadius: true,
  splitPayment: true,
  wishlistShare: true,
  bookingCalendar: true,
  autoApprove: true,
  returnPolicy: true,
  multiVariant: true,
  floorPlan: true,
  priceHistory: true,
  bulkMessaging: true,
  listingQA: true,
  groupBooking: true,
  smartPricing: true,
  subscriptionBox: true,
  adminBadge: true,
  stockNotify: true,
  earningsCalculator: true,
  disputeResolution: true,
  chatTranslate: true,
  customFields: true,
  auctionBidding: true,
  leadCapture: true,
  npsRating: true,
  giftCard: true,
  crossSell: true,
  bookingInsurance: true,
  providerCalendar: true,
  chatbot: true,
  serviceArea: true,
  listingCondition: true,
  listingSpotlight: true,
  appointmentSlots: true,
  userSubscription: true,
  socialConnect: true,
  proofOfDelivery: true,
  carbonOffset: true,
  providerRanking: true,
  embeddedVideo: true,
  documentVerification: true,
  listingWizard: true,
  bookingBuffer: true,
  listingAnalytics: true,
  coHosting: true,
  minimumBookingPeriod: true,
  urgencyCountdown: true,
  priceAlerts: true,
  reviewHighlights: true,
  businessHours: true,
  bulkListingEdit: true,
  mapView: true,
  profilePortfolio: true,
  tierDiscount: true,
  messagePinning: true,
  locationSuggester: true,
  abandonedProposal: true,
  seasonalPricing: true,
  quickReply: true,
  listingCertification: true,
  viewHistory: true,
  paymentPlan: true,
  hostBadge: true,
  autoResponse: true,
  searchRadius: true,
};
